import { t } from '../i18n';

/** Opt-in mobile card layout for `.data-table` (see `.data-table--cards` CSS). */
export function enhanceDataTableCards(table: HTMLTableElement): void {
  table.classList.add('data-table--cards');

  const headerRow = table.tHead?.rows[0];
  if (!headerRow) {
    return;
  }

  const headers = Array.from(headerRow.cells).map((th) => {
    const i18nKey = th.getAttribute('data-i18n');
    const translated = i18nKey ? t(i18nKey) : null;
    const label = (translated ?? th.textContent ?? '').trim();
    return {
      label,
      isActions: th.classList.contains('data-table__actions-heading'),
    };
  });

  for (const body of Array.from(table.tBodies)) {
    for (const row of Array.from(body.rows)) {
      if (row.querySelector('td[colspan]')) {
        continue;
      }
      Array.from(row.cells).forEach((td, index) => {
        const header = headers[index];
        const label = header?.label ?? '';
        if (label) {
          td.setAttribute('data-label', label);
        } else {
          td.removeAttribute('data-label');
        }
        if (header?.isActions) {
          td.classList.add('data-table__actions');
        }
      });
    }
  }
}
